import { render, staticRenderFns } from "./AboutModal.vue?vue&type=template&id=5287b09a&scoped=true&"
import script from "./AboutModal.vue?vue&type=script&lang=js&"
export * from "./AboutModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5287b09a",
  null
  
)

export default component.exports